import { useTheme } from '@ixigo/iui/theme';
import { useEffect } from 'react';
import { setThemeColor } from './set-theme-color';
import { ThemeColors } from './theme-colors';

export function ThemeColorSync() {
	const theme = useTheme((state) => state.theme);

	useEffect(() => {
		if (theme) setThemeColor(ThemeColors[theme]);
	}, [theme]);

	// The startup script owns the tag; React must not hydrate it as hoisted metadata.
	return null;
}
